import { useNavigate } from "react-router-dom";
import "./MHW.css";

const HungerPage = () => {
  const navigate = useNavigate();

  return (
    <div className="mhw-container">
        
                   <button className="back-btn" onClick={() => navigate(-1)}>
        ← Go Back
      </button>
      <h2>Hunger Service Week</h2>

      <div className="btn-group">
        <button onClick={() => navigate("/hunger-awards")} className="mhw-btn">
          Awards
        </button>

        <button onClick={() => navigate("/hunger-blog")} className="mhw-btn outline">
          Blog
        </button>
      </div>
    </div>
  );
};

export default HungerPage;